import React from 'react'

import { InstitutionLogo, P } from '@mxenabled/mxui'

import Paper from '@mui/material/Paper'

interface BodyHeaderProps {
  account: { guid: string; logo_alt_text: string }
  headerString: string
}

const LOGO_SIZE = 48

export const FullFeedBodyHeader: React.FC<BodyHeaderProps> = ({ account, headerString }) => {
  return (
    <>
      <Paper
        elevation={1}
        sx={(theme) => ({
          height: LOGO_SIZE,
          width: LOGO_SIZE,
          borderRadius: '6px',
          outline: `1.2px solid ${theme.palette.neutral?.light}`,
          marginTop: -22,
          zIndex: 10,
        })}
      >
        <InstitutionLogo
          alt={account.logo_alt_text}
          height={LOGO_SIZE}
          institutionGuid={account.guid || ''}
          width={LOGO_SIZE}
        />
      </Paper>
      <P bold={true} sx={{ width: '100%', textAlign: 'center' }}>
        {headerString}
      </P>
    </>
  )
}
